import { moment } from "@msuite/utils/date";
import { getSettlementRecordState } from "@msuite/utils/partnerships";
import type { BookingsReviewListItem } from "@msuite/utils/types";
import { SettlementStateTag } from "@/components/partners";

/** Props Interface */
interface DashboardPartnerBookingDueItemProps {
	booking: BookingsReviewListItem;
}

/** One record the partner still owes hours on: which day, which site, whose, where it stands. */
export function DashboardPartnerBookingDueItem({ booking }: DashboardPartnerBookingDueItemProps) {
	/** Computed */
	const state = getSettlementRecordState({
		isApproved: booking.isApproved,
		isReviewed: booking.isReviewed,
		hasBookings: (booking.ticketAssignmentReferenceBookings?.length ?? 0) > 0,
	});

	/** Render */
	return (
		<>
			<div className="v-stack gap-0 items-start text-left min-w-0">
				<p className="truncate max-w-full">{moment(booking.date).dateFormat()}</p>
				<p className="truncate max-w-full">
					<span className="font-semibold">{booking.project.name}</span>
					{booking.project.number ? (
						<span className="font-normal">{` (${booking.project.number})`}</span>
					) : null}
				</p>
			</div>
			<div className="flex-1" />
			<div className="v-stack gap-0 items-end shrink-0 pl-3">
				<SettlementStateTag
					state={state}
					variant="plain"
				/>
				<p className="truncate max-w-full">{booking.hostOrganizationName}</p>
			</div>
		</>
	);
}
